import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';
import { Cat, Dog } from './icons';

const Variants = cva('px-3 py-1 w-fit rounded-xl icon-wrapper font-semibold ', {
  variants: {
    petType: {
      dog: 'bg-data-viz-01 text-data-viz-01-foreground',
      cat: 'bg-accent text-accent-foreground',
    },
  },
  defaultVariants: {
    petType: 'dog',
  },
});

export interface PetTagProps {
  type?: string;
}
function PetTag({ type = 'dog', ...props }: PetTagProps) {
  const petType = type === 'cat' ? 'cat' : 'dog';

  return (
    <div className={cn(Variants({ petType }))} {...props}>
      {type === 'dog' ? <Dog size={16} /> : <Cat size={16} />}
      <p className="text-b3">{type === 'dog' ? 'Dog' : 'Cat'}</p>
    </div>
  );
}

export { PetTag, Variants };
